import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export function useIncompleteManualRemittance(
  email,
  currentOrganization,
  queryItemKey
) {
  const { oktaAuth } = useOktaAuth();

  // Safely access currentOrganization properties to prevent "Cannot read properties of null" error
  const orgValue =
    currentOrganization && currentOrganization.value
      ? currentOrganization.value
      : null;
  const orgType =
    currentOrganization && currentOrganization.type
      ? currentOrganization.type
      : null;

  const queryKey = [queryItemKey, email, orgValue, orgType];

  async function fetchIncompleteManualRemittance() {
    const accessToken = oktaAuth.getAccessToken();

    if (email && currentOrganization && orgValue && orgType) {
      const result = await axios
        .get("api/ManualRemittance/GetIncompleteManualRemittanceForUserEmail", {
          params: {
            email: email,
            organizationId: orgValue,
            organizationType: orgType,
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    } else {
      return null;
    }
  }

  function isEnabled() {
    // if organization is not set, or does not have a value
    try {
      // Check if currentOrganization exists first before accessing its properties
      if (IsNullOrEmpty(currentOrganization)) {
        return false;
      }

      // Now we can safely check the value property
      if (IsNullOrEmpty(orgValue)) {
        return false;
      }

      // Now we can safely check the type property
      if (IsNullOrEmpty(orgType)) {
        return false;
      }

      // if email is not set, or does not have a value
      if (IsNullOrEmpty(email)) {
        return false;
      }
    } catch (error) {
      console.error(
        "Error in useIncompleteManualRemittance:isEnabled function: ",
        error
      );
      return false;
    }

    return true;
  }

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => await fetchIncompleteManualRemittance(),
    enabled: isEnabled(),
  });
}
